import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { SelectComponent } from '@core/user-interface-legacy';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { CurrencySelectors } from '@recruitee/currency-data';

@Component({
  selector: 'rt-currency-select-field',
  template: `
    <rt-select
      [formControl]="form()"
      [hasInputTrigger]="true"
      [searchPlaceholder]="searchPlaceholder()"
      [groupedOptions]="selectGroupedOptions()"
      [hasClearButton]="hasClearButton()"
      [disabled]="isDisabled()"
      [readOnly]="isReadOnly()"
      [placeholder]="placeholder()"
      [isInvalid]="isInvalid()"
    />
  `,
  imports: [SelectComponent, ReactiveFormsModule],
})
export class CurrencySelectFieldComponent {
  private readonly store = inject(Store);

  public readonly form = input<FormControl>(undefined!);
  public readonly searchPlaceholder = input<string>(undefined!);
  public readonly placeholder = input<string>(undefined!);
  public readonly isDisabled = input<boolean>(false);
  public readonly isReadOnly = input<boolean>(false);
  public readonly hasClearButton = input<boolean>(false);
  public readonly isInvalid = input<boolean>(false);

  public selectGroupedOptions = toSignal(
    this.store.select(CurrencySelectors.entities()).pipe(
      filter(list => !!list.length),
      map(currencies =>
        currencies.map(item => ({
          value: item.code,
          label: `${item.name} (${item.code})`,
        })),
      ),
      map(options => [
        {
          title: null,
          options,
        },
      ]),
    ),
    { initialValue: [] },
  );
}
